import { createUseStyles } from 'react-jss';

import { FontWeight, ITheme, mediaQuery } from '../../../styles';

import { MENU_COLLAPSE_BREAKPOINT } from './config';

const useStyles = createUseStyles(
  ({ colors, breakpoints }: ITheme) => ({
    root: {},
    navMobileTitle: {
      display: 'none',
      padding: '27px 24px 29px 24px',
      gap: '16px',
      alignItems: 'center',
      fontSize: '20px',
      fontWeight: FontWeight.SemiBold,
      lineHeight: '22px',
      background: '#ffffff',
    },
    navMobileTitleText: {
      display: 'flex',
      gap: 16,
    },
    icon: {
      cursor: 'pointer',
      fill: 'var(--x-black-1)',
    },
    navContainer: {
      display: 'flex',
      background: '#ffffff',
      flex: 1,
      zIndex: 102,
    },
    navbarItem: {
      position: 'relative',
      cursor: 'pointer',

      '&:first-child $navbarItemLabel': {
        paddingLeft: 44,
      },

      '&:hover': {
        '& > $navbarSubItems': {
          display: 'block',
        },

        '&:hover $navbarItemLabel': {
          color: colors.primary,
        },

        '&:hover $navItemArrow': {
          marginTop: 4,
          transform: 'rotate(0.5turn)',
        },
      },
    },
    navbarItemLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: '2px',
      padding: '0 14px',
      height: '80px',
      color: '#222222',
      fontSize: '14px',
      fontWeight: FontWeight.SemiBold,
      lineHeight: '22px',
      position: 'relative',

      [mediaQuery(breakpoints.desktop)]: {
        padding: '0 8px',
      },
    },
    navItemArrow: {
      fill: colors.primary,
    },
    navbarSubItems: {
      zIndex: 105,
      background: '#ffffff',
      position: 'absolute',
      display: 'none',
      width: '262px',
      top: '100%',
      left: 0,
      boxShadow: '0px 4px 16px rgba(17, 18, 54, 0.16)',
      borderRadius: '16px',
      margin: 0,
      padding: '12px 24px',

      '&$navbarSubItemsApp': {
        top: 0,
        left: '100%',
        bottom: 0,
        width: 'max-content',
      },
    },

    navbarSubItemsApp: {
      boxShadow: '10px 4px 5px -2px rgba(17, 18, 54, 0.16)',
      marginLeft: '-25px',
    },

    borderLeft: {
      borderLeft: '1px solid var(--x-bg-8)',
      display: 'block',
      height: '96%',
      position: 'relative',
      marginTop: 5,
      marginLeft: '-8px',
      width: 16,
    },
    subCategoryItem: {},
    lastItemContainer: {
      listStyle: 'none',
      padding: 0,
    },
    lastItem: {
      color: 'var(--x-text-color-4)',
    },
    navbarSubItem: {
      listStyle: 'none',
      padding: 0,

      '&:hover': {
        '& $subCategoryArrow': {
          fill: colors.primary,
        },

        '& $navbarSubItemsApp': {
          display: 'flex',
        },

        background: 'var(--x-bg-5)',
        borderRadius: 8,
      },

      '&$subCategoryItem': {
        paddingLeft: 14,
        paddingRight: 14,
      },
    },

    subCategoryItemsContainer: {
      listStyle: 'none',
      padding: '0',
    },

    iconContainer: {
      display: 'flex',
      gap: 10,
    },
    navbarSubItemLink: {
      color: '#222222',
      fontSize: '14px',
      fontWeight: FontWeight.SemiBold,
      lineHeight: '32px',
      padding: 4,
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      justifyContent: 'space-between',

      '& $navItemArrow': {
        display: 'none',
      },

      '&$lastItem': {
        color: 'var(--x-text-color-4)',
      },
    },
    burgerMenu: {
      display: 'none',
      cursor: 'pointer',
      fill: 'var(--x-black-1)',

      [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
        display: 'block',
      },
    },
    backdrop: {
      display: 'none',
      background: 'rgba(40, 43, 54, 0.4)',
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      width: '100%',
      height: '100vh',
      zIndex: 101,

      [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
        '&.isVisible': {
          display: 'block',
        },
      },
    },
    label: {
      color: 'var(--x-text-color-5)',
    },
    bullet: {
      height: 10,
      width: 10,
      backgroundColor: '#FE9D24',
      borderRadius: 50,
      marginRight: 'auto',
      marginLeft: 6,
      marginBottom: '12px',
    },

    mobile: {
      [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
        '&$root': {
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          flexDirection: 'column',
          height: '100vh',
          display: 'none',
          zIndex: 102,
          maxWidth: '288px',

          '&$root.isVisible': {
            display: 'flex',
          },
        },
        '& $navMobileTitle': {
          display: 'flex',
          justifyContent: 'space-between',
        },
        '& $navbarItem': {
          position: 'static',

          '&:first-child $navbarItemLabel': {
            paddingLeft: 24,
          },
          '&:hover > $navbarSubItems': {
            display: 'none',

            '& $navbarSubItemsApp': {
              boxShadow: 'none',
              // marginLeft: 0,
            },
          },
          '&:hover > $navbarSubItems.isMobileActive': {
            display: 'block',
          },
          '&:hover $navItemArrow': {
            transform: 'rotate(0.75turn)',
            marginTop: 0,
          },
        },
        '& $navContainer': {
          flexDirection: 'column',
          position: 'relative',
        },
        '& $navbarItemLabel': {
          justifyContent: 'space-between',
          fontSize: '16px',
          fontWeight: FontWeight.Medium,
          padding: '11px 24px',
          height: 'auto',
        },
        '& $navbarSubItems': {
          zIndex: 105,
          top: '0',
          left: '-100%',
          bottom: '0',
          right: '0',
          width: '100%',
          boxShadow: 'none',
          overflowY: 'auto',
          padding: '0 0 24px 0',

          transition: 'left 0.35s',
          display: 'block !important',

          '&.isMobileActive': {
            left: 0,
          },
        },
        '& $navItemArrow': {
          transform: 'rotate(0.75turn)',
        },
        '& $navbarSubItemLink': {
          display: 'flex',
          fontSize: '16px',
          fontWeight: FontWeight.Medium,
          padding: '11px 24px',
        },
        '& $borderLeft': {
          display: 'none',
        },

        '& $navbarSubItemsApp': {
          marginLeft: 0,
        },
      },
    },
    searchActive: {},
    search: {
      left: '-100%',
      position: 'relative',
      transition: 'left 0.35s',

      '&$searchActive': {
        left: 0,
      },
    },
    searchContainer: {
      backgroundColor: '#fff',
      height: '100%',
      padding: '0 24px',
      width: '100%',

      '& input': {
        width: '100%',
      },

      '& .search-results': {
        padding: '20px 0 0 0',
        boxShadow: 'none',
        textAlign: 'left',
        width: '100%',

        '& p': {
          marginInlineStart: 0,
        },
      },
    },

    subCategoryArrow: {
      display: 'block',
      fill: 'black',
      marginRight: 10,
    },
    new: {
      marginRight: 4,
      marginBottom: 12,

      [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
        marginBottom: 0,
        position: 'absolute',
        right: 48,
      },
    },
    toolLabels: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
    },
  }),
  { name: 'single-tools-navbar' },
);

export default useStyles;
